/**
 * 滚到主页发布框，使其处于与页面顶部相同的可视位置（导航下方主内容区顶部）。
 * 已对齐时不滚动，避免在页顶点击时多滑一点。
 */
export function scrollToPostComposer() {
  const el = document.getElementById("post-composer");
  if (!el) return;

  const main = document.querySelector(".layout-main");
  const mainPadTop = main
    ? parseFloat(window.getComputedStyle(main).paddingTop) || 75
    : 75;

  // 与页顶静止时一致：发布框顶边落在主内容 padding 位置
  const desiredViewportTop = mainPadTop;
  const delta = el.getBoundingClientRect().top - desiredViewportTop;

  if (Math.abs(delta) < 2) return;

  window.scrollTo({
    top: Math.max(0, window.scrollY + delta),
    behavior: "smooth",
  });
}
